var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flight-listbox"},[_c('div',{staticClass:"serch-loading-img text-c"},[_c('img',{style:(_vm.big==true?'width:120px':'width:30px'),attrs:{"src":require("../assets/serch_loading.gif")}})])])}
var staticRenderFns = []

export { render, staticRenderFns }